import { Grid, Switch } from '@mui/material'
import SoftBox from 'components/SoftBox'
import React, { useState } from 'react'
import { useAgencyInfo } from "context/agency";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftTypography from 'components/SoftTypography'
import env from "config/env";
import FormField from "layouts/pages/account/components/FormField";

function SocialCelender({handleImage, handleSubmit, loading}) {
  const [agency] = useAgencyInfo();
  
  return (
    <SoftBox component="form" onSubmit={handleSubmit}>
    <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
      <Grid item xs={12}>
        <SoftTypography variant="h5" style={{ marginBottom: '8px' }}>Celender Setting</SoftTypography>
      </Grid>
      
   
     
      <Grid item xs={6} className='px-2'>
        <FormField
          defaultValue={agency?.Customization?.celender_m_title}
          label=" Meta Title"
          name="celender_m_title"
        />
      </Grid>
      <Grid item xs={6} className='px-2'>
        <FormField
          defaultValue={agency?.Customization?.celender_m_description}
          label="Celender Meta Description"
          name="celender_m_description"
        />
      </Grid>
      <Grid item xs={12} className='px-2' display="flex" justifyContent={"flex-end"}>
           
            <SoftButton className="bg-dark" color="dark" type="submit"
            disabled={loading} // Disable the button while loading
            style={{
              cursor: loading ? 'not-allowed' : 'pointer', // Change cursor to 'not-allowed' (red circle) while loading
            }}
            >
              update
            </SoftButton>
            
          </Grid>
    </Grid>
  </SoftBox>
  )
}

export default SocialCelender
